import { RQ } from 'utils';
import { addClickAnalytics } from 'utils/analytics';
import qs from 'querystring';
import pathData from './path';
import filter from 'lodash/filter';
export default {
  // getInfo: async function () {
  //   let self = this;
  //   let d = await RQ.mall.get('/api/app/enterprise/property/getEnterpriseProperty', {
  //     enterpriseNo: self.enterprise,
  //     protocolType: self.protocolType
  //   }, {
  //     enterprise: '00'
  //   });
  //   if (d && d.code == 0) {
  //     console.log(d, d.data, d.data.enterpriseNo);
  //     self.info = d.data;
  //   }
  // },
  checkEnv () {
    let self = this;
    if (window.__wxjs_environment === 'miniprogram') {
      this.env = 'mini';
    } else if (window.ReactNativeBridge) {
      this.env = 'app';
      window.ReactNativeBridge.call('APP_INFO', {
        success: (res) => {
          console.log(res);
          self.appInfo = res.data;
        },
        fail: (err) => {
          console.error(err)
        }
      });
    } else {
      this.env = 'web';
    }
  },
  handleDialog () {
    this.showActivityDialog = false;
  },
  handleClick (e, item,paramsData,listItem) {
    console.log('--------window', window, this.env, this)
    if(paramsData &&paramsData.show_type == 2 || (paramsData &&!paramsData.show_type && (listItem.moduleType == 0 ||  listItem.moduleType == 1 ))) {
      return
    }
    const {channel, enterprise} = this;
    var params = item.actionParams ? (item.actionParams == "" ? {} : JSON.parse(item.actionParams)) : '';
    var actionParamsStr = "";
    var goodsId = "";
    var key;
    for (key in params) {
      if(key == 'goodsId'){
        goodsId = params[key]
      }
      // if(key =='params'){
      //   actionParamsStr = ''+  `&params={"presaleGiftIds":27,"presaleGiftId":27,b":27,"c":27}`;
      // } [obj,obj]
      //params多个参数 传字符串
      if(key =='params'){
        actionParamsStr += `&${key}=${encodeURIComponent(JSON.stringify(params[key]))}`;
      }else{
        actionParamsStr += `&${key}=${params[key]}`;
      }
    }
    if (this.__canceling__ !== true){
      this.__canceling__ = true;
      if (window.__wxjs_environment === 'miniprogram') {
        // wxapp
        if (item.actionUrl && item.actionType == "url") {
          const pageName = item.actionUrl.substring(0,1).toLowerCase().concat(item.actionUrl.substring(1));
          const prePath = filter(pathData.pathObj, { "name":`${pageName}` })[0].path;
          const path = `${prePath}?from=webview&isShowMenu=true${actionParamsStr}`;
          console.log('actionParamsStr~~~~111',actionParamsStr,params,item.actionParams)
          // const path = `/pages/yWebView/index?paramsNo=2019092415110573608867`;
          wx.miniProgram.navigateTo({url: `${path}&original=wxapp&channel=${channel}&enterprise=${enterprise}`});
        }else if(paramsData && !paramsData.show_type){
          const {path, goodsId} = item;
          addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_wxapp_channel_${channel}` });
          wx.miniProgram.navigateTo({url: `${path}&original=wxapp&channel=${channel}&enterprise=${enterprise}`});
        }
      } else if (window.ReactNativeBridge) {
        // app
        if (paramsData && !paramsData.show_type || (item.actionUrl && item.actionType == "url" && paramsData.show_type)) {
          const {goodsId, specialId, groupGiftId} = item || {};
          if (params == '') {
            params = {goodsId, specialId, groupGiftId}
          }
          window.ReactNativeBridge.call('NAVIGATION', {
            id: paramsData && !paramsData.show_type ? 'Goods':item.actionUrl,
            params: {
              ...params, original: 'app', channel, enterprise
            },
            success: (res) => {
              console.log(res);
            },
            fail: (err) => {
              console.error(err)
            }
          })
        }
      } else {
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
      }
      console.log('-----------this.env', this.env);
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  },
  goToGoodsDetail(item,paramsData) {
    if(paramsData && paramsData.show_type == 2){
      return
    }
    if (this.__canceling__ !== true){
      this.__canceling__ = true;
      // wxapp
      const {channel,enterprise} = this;
      const {goodsId,groupGiftId} = item;

      if (window.__wxjs_environment === 'miniprogram') {
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_wxapp_channel_${channel}` });
        const path = `/pages/goods/index?from=webview&isShowMenu=true&goodsId=${goodsId}&groupGiftId=${groupGiftId}`
        wx.miniProgram.navigateTo({url: `${path}&original=wxapp&channel=${channel}&enterprise=${enterprise}`});
      }else if (window.ReactNativeBridge) {
        // app
        addClickAnalytics({ LogTitle: `浏览活动商品_${item.goodsId}_app_channel_${channel}` });
        window.ReactNativeBridge.call('NAVIGATION', {
          id: 'Goods',
          params: {
            goodsId, groupGiftId, original: 'app', channel, enterprise
          },
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        })
      } else {
        addClickAnalytics({ LogTitle: `浏览活动商品_${goodsId}_h5_channel_${channel}` });
        if (this.isPlatform === 1) {
          window.location.href = 'http://leadmall-c.yolipai.net/meidd.html';
        }
      }
      setTimeout(() => {
        this.__canceling__ = false
      }, 1000)
    }
  },
  submitFn (queryStr) {
    const {appName = ''} = this.appInfo;
    // 判断浏览器
    const u = navigator.userAgent;
    if (/MicroMessenger/gi.test(u)) {
      // 引导用户在浏览器中打开
      alert('请在浏览器中打开');
      return;
    }
    const d = new Date();
    const t0 = d.getTime();
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
      // Android
      if (this.openApp('dgxym://Goods' + queryStr)) {
        this.openApp('dgxym://Goods' + queryStr);
      } else {
        // 由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
        const delay = setInterval(function(){
          const d = new Date();
          const t1 = d.getTime();
          if (t1 - t0 < 3000 && t1 - t0 > 2000) {
            alert(`请下载${appName}APP`);
            window.location.href = "http://leadmall-c.yolipai.net/download?enterprise=E201805211013467576";
          }
          if (t1 - t0 >= 3000) {
            clearInterval(delay);
          }
        }, 1000);
      }
    } else if (u.indexOf('iPhone') > -1) {
      // IOS
      if (this.openApp('ios--dgxym://Goods' + queryStr)) {
        this.openApp('ios--dgxym://Goods' + queryStr);
      } else {
        const delay = setInterval(function(){
          const d = new Date();
          const t1 = d.getTime();
          if(t1-t0<3000 && t1-t0>2000){
            alert(`请下载${appName}APP`);
            window.location.href = "http://leadmall-c.yolipai.net/download?enterprise=E201805211013467576";
          }
          if(t1-t0>=3000){
            clearInterval(delay);
          }
        },1000);
      }
    }
  },
  openApp (src) {
  // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
  // 否则打开a标签的href链接
    const ifr = document.createElement('iframe');
    ifr.src = src;
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    window.setTimeout(function () {
      document.body.removeChild(ifr);
    }, 2000);
  },
  // 生成活动数据
  generatePageData () {
    const { day, goodsList, business, enterprise, period } = this;
    const mark = `${business[enterprise].name}${day}${period}`;
    this.pageData = (goodsList[mark] || []).map(item => {
      switch (item.moduleType) {
        case 0:
        case 1: {
          return {
            ...item,
            floorDetailList: item.floorDetailList.map((count, index) => {
              return {
                url: `/static/img/activity/${mark}/${item.imgName}-${count}.${item.picType || 'jpg'}`
              }
            })
          }
        }
        case 2:
        case 3: {
          return {
            ...item,
            floorDetailList: item.floorDetailList.map((goods, index) => {
              return {
                ...goods,
                url: `/static/img/activity/${mark}/${item.imgName}-${index + 1}.${goods.picType || 'jpg'}`,
                path: `/pages/goods/index?from=webview&isShowMenu=true&${qs.stringify(goods)}`
              }
            })
          }
        }
      }
    })
  },
  // 取出日期 (取第三位做随机数，剩余数拼接，两者相除，可得日期，eg: '12390' -> '1290' / '3' = '430' -> '0430')
  getDay (str) {
    if (!str || typeof str !== 'string') return;
    console.log(str.substring(0, 2), str.substring(3), str.substring(3))
    const day = String((str.substring(0, 2) + str.substring(3)) / str.substring(2, 3));
    return day.length < 4 ? '0' + day : day
  }
};



// WEBPACK FOOTER //
// ./src/module/app/activityPage/action.js